// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"1117938dd482e9108fe0","713":"bfe5505578470e76d84e","731":"50a6dabafe7d779dd9de","843":"4d22e4d87d98fa226c97","883":"d3d00c7c3cf989df596a"}[chunkId] + ".js";
};